<div>
    <div class="header-layout">
        <div class="left">
            <h4>L{{leadDetails?.id}}</h4>
        </div>
        <div class="right">
            <button type="button" name="createUser" class="close-action" (click)="closeDialog()">
                Close
            </button>
            <button type="button" name="createUser" *ngIf="regionCode ==='India' && data.tab!='report'" (click)="navigatePage(leadDetails.id)"
                class="edit-action">
                <img class="icon-edit cursor-pointer " src="assets/images/edit.png" alt="edit" />
                Edit</button>
            <button type="button" name="createUser" *ngIf="regionCode ==='Mexico' && data.tab!='report' && (permissions.update && permissions.delete && permissions.create && permissions.read)" (click)="navigatePageForMexico(leadDetails.id)"
                class="edit-action">
                <img class="icon-edit cursor-pointer " src="assets/images/edit.png" alt="edit" />
                Edit</button>
            <button type="button" name="createUser" *ngIf="regionCode ==='Egypt' && data.tab!='report' && (permissions.update && permissions.delete && permissions.create && permissions.read)" (click)="navigatePageForEgypt(leadDetails.id)"
                class="edit-action">
                <img class="icon-edit cursor-pointer " src="assets/images/edit.png" alt="edit" />
                Edit</button>
            <button type="button" name="createUser" class="create-action"
                *ngIf="regionCode ==='India' && data.tab=='Received' && data.tab!='report' " (click)='assignLead()'>
                <img class="icon-edit cursor-pointer " src="assets/images/tick.png" alt="assign" />
                Assign
            </button>
            <button type="button" name="createUser" class="create-action"
                *ngIf="regionCode ==='India' && data.tab=='actionRequired' && data.tab!='report' " (click)='assignActionRequiredLead()'>
                <img class="icon-edit cursor-pointer " src="assets/images/tick.png" alt="edit" />
                Assign
            </button>
            <button type="button" name="createUser" class="create-action"
                *ngIf="regionCode ==='India' && data.tab!='Received' && data.tab!='actionRequired' && data.tab!='report'"
                (click)='reAssignLead()'>
                <img class="icon-edit cursor-pointer " src="assets/images/tick.png" alt="edit" />
                Reassign
            </button>
            <button type="button" name="createUser" class="reject-action" (click)="rejectLead()"
                *ngIf="regionCode ==='India' && data.tab!='Rejected' && data.tab!='report'">
                <img class="icon-edit cursor-pointer " src="assets/images/deletered.png" alt="edit" />
                Reject</button>
        </div>
    </div>
    <hr />
    <div class="col-sm-12 row p-0">
        <div class="col-sm-12 p-b">
            <h4>
                Personal information
            </h4>
        </div>
        <div class="col-sm-4">
            <h3>Customer Name</h3>
            <p>{{leadDetails?.name}}</p>
        </div>
        <div class="col-sm-4">
            <h3>Phone</h3>
            <p>{{leadDetails?.phone}}</p>
        </div>
        <div class="col-sm-4">
            <h3>Email</h3>
            <p>{{leadDetails?.email_id}}</p>
        </div>
        <div class="col-sm-4">
            <h3>Address</h3>
            <p>{{leadDetails?.residental_address}}</p>
        </div>
        <div class="col-sm-12 p-b">
            <h4>
                Store information
            </h4>
        </div>
        <div class="col-sm-4">
            <h3>Store Name</h3>
            <p>{{leadDetails?.store_name}}</p>
        </div>
        <div class="col-sm-4">
            <h3>P.Business</h3>
            <p>{{leadDetails?.primary_business.primary_business}}
            </p>
        </div>
        <div class="col-sm-4" *ngIf="leadDetails?.primary_business.id==13">
            <h3>Type of Business</h3>
            <p>{{leadDetails?.other_business}}</p>
        </div>
        <div class="col-sm-4">
            <h3>Address</h3>
            <p>{{leadDetails?.store_address}}</p>
        </div>
        <div class="col-sm-4" *ngIf="regionCode ==='Egypt'">
            <h3>Number of Employees</h3>
            <p>{{leadDetails?.no_of_employees}}</p>
        </div>
        <div class="col-sm-4" *ngIf="leadDetails?.status!=4">
            <h3>Location</h3>
            <p>{{leadDetails?.location}}</p>
        </div>
        <div class="col-sm-4" *ngIf="leadDetails?.status==4">
            <h3>Location</h3>
            <span>lattitude-{{leadDetails?.location.lat | number : '.2-2'}}</span><br>
            <span>longitude-{{ leadDetails?.location.long | number : '.2-2'}}</span>
        </div>
        <div class="col-sm-4" *ngIf="regionCode ==='Egypt'">
            <h3>Store Area</h3>
            <p>{{leadDetails?.store_area}}</p>
        </div>
        <div class="col-sm-12 p-b">
            <h4>
                Documents
            </h4>
        </div>
        <div class="col-sm-4 " *ngIf="regionCode ==='Mexico' && leadDetails?.is_official_id_available">
            <h3>Official Id</h3>
            <p>{{leadDetails?.is_official_id_available=='false'?'no':'yes'}}</p>
        </div>
        <div class="col-sm-4 " *ngIf="regionCode ==='India' && leadDetails?.is_voterid_available">
            <h3>Voter Id</h3>
            <p>{{leadDetails?.is_voterid_available=='false'?'no':'yes'}}</p>
        </div>
        <div class="col-sm-4 " *ngIf="regionCode ==='India' && leadDetails?.is_dl_available">
            <h3>Driving License</h3>
            <p>{{leadDetails?.is_dl_available=='false'?'no':'yes'}}</p>
        </div>
        <div class="col-sm-4 " *ngIf="regionCode ==='India' && leadDetails?.is_pan_available">
            <h3>Pan Card</h3>
            <p>{{leadDetails?.is_pan_available=='False'?'no':'yes'}}</p>
        </div>
        <div class="col-sm-4 " *ngIf="regionCode ==='India' && leadDetails?.is_passport_available">
            <h3>Passport</h3>
            <p>{{leadDetails?.is_passport_available=='false'?'no':'yes'}}</p>
        </div>
        <div class="col-sm-4 " *ngIf="regionCode ==='Egypt' && leadDetails?.tax_id">
            <h3>Tax ID</h3>
            <p>{{leadDetails?.tax_id=='false'?'no':'yes'}}</p>
        </div>
        <div class="col-sm-4 " *ngIf="regionCode ==='Egypt' && leadDetails?.commercial">
            <h3>Commercial Registration</h3>
            <p>{{leadDetails?.commercial=='false'?'no':'yes'}}</p>
        </div>
        <div class="col-sm-4 ">
            <h3>Bank Account</h3>
            <p>{{leadDetails?.is_bank_available=='False'?'no':'yes'}}</p>
        </div>
        
        <div class="col-sm-4 " *ngIf="regionCode ==='India' && leadDetails?.is_aadhar_available">
            <h3>Aadhar Card</h3>
            <p>{{leadDetails?.is_aadhar_available=='false'?'no':'yes'}}</p>
        </div>
        
        <div class="col-sm-12 p-b" *ngIf="regionCode ==='India'">
            <h4>
                Ihs details
            </h4>
        </div>
        <div class="col-sm-4" *ngIf="regionCode ==='India' && leadDetails?.intrested">
            <h3>Interested for</h3>
            <p>{{leadDetails?.intrested}}</p>
        </div>
    </div>
    <div class="col-sm-12 p-0" *ngIf="regionCode ==='India'">
        <div class="p-b">
            <h4>Activity log</h4>
        </div>
        <div class="list-wrapper" *ngFor="let activity of content;let lastItem = last;">
            <div class="red-line" *ngIf="!lastItem"></div>
            <div class="list-item-wrapper">
                <div class="list-bullet"></div>
                <div class="list-item">
                    <div class="list-title">
                        {{activity.created_at | date: 'dd/MM/yyyy' }},{{activity.created_at | date: 'hh:mm a'}}</div>
                    <div class="list-text">{{activity.message}}</div>
                    <div class="white-line"></div>
                </div>
            </div>
        </div>
        <div class="showmore">
            <a class="show-more" (click)="getMoreData(data.leadId)" *ngIf="counter >= content.length"
                [hidden]="counter > content.length">
                Show more
            </a>
        </div>
        <!-- <div class="showmore">
            <a class="show-more" (click)="getLessData(data.leadId)" *ngIf="counter >= content.length"
                [hidden]="content.length > counter">
                Show Less
            </a>
        </div> -->
    </div>
</div>